<template>
  <Section>
    <SectionHeader :title="$t('apps.billing.message.summarybyservice')"/>
    <FormRow>
      <Col className="col-lg-12">
      <BaseTable
        class="custom-table"
        tableClass="table-bordered"
        hidePagination
      >
        <template #thead>
          <thead>
            <tr>
              <th style="width: 125px;">{{ $t('apps.billing.label.item') }}</th>
              <th style="width: 150px;">{{ $t('apps.billing.label.detail') }}</th>
              <th class="text-center">{{ $t('apps.billing.label.usedwithcharge') }}</th>
              <th class="text-center">{{ $t('apps.billing.label.unitprice') }}</th>
              <th
                style="width: 140px;"
                class="text-right">{{ $t('apps.billing.label.payamount') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="empty"
                colspan="5"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <!-- Application -->
            <tr
              v-for="(item, index) in apps"
              :key="index"
            >
              <td>
                {{ item.app.title }}
              </td>
              <td style="border-right: 1px solid #dee2e6;">
                {{ item.module.title }}
              </td>
              <td class="text-center">
                {{ item.chargeUsedTotal }}
              </td>
              <td class="text-center">
                {{ getCurrencyWithNumber(numberel(item.unitPrice, '0,0.00')) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(item.amountTotal, '0,0.00')) }}
              </td>
            </tr>
            <!-- Branch -->
            <tr v-if="showBranches">
              <td>
                {{ $t('apps.billing.message.branch') }}
              </td>
              <td>
                {{ $t('apps.billing.message.branchcount') }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.branches', { number: getRangeMinMax(data.branchUsedCountMin, data.branchUsedCountMax, data.branchUsedCount, { format: '0,0' }) }) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.unitpricebranch', { number: getCurrencyWithNumber(numberel(data.branchUnitPrice, '0,0.00')) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.branchAmountTotal, '0,0.00')) }}
              </td>
            </tr>
            <!-- Warehouse -->
            <tr v-if="showWarehouses">
              <td>
                {{ $t('apps.billing.message.warehouse') }}
              </td>
              <td>
                {{ $t('apps.billing.message.warehousecount') }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.warehouses', { number: getRangeMinMax(data.warehouseUsedCountMin, data.warehouseUsedCountMax, data.warehouseUsedCount, { format: '0,0' }) }) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.unitpricewarehouse', { number: getCurrencyWithNumber(numberel(data.warehouseUnitPrice, '0,0.00')) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.warehouseAmountTotal, '0,0.00')) }}
              </td>
            </tr>
            <!-- User -->
            <tr v-if="showUsers">
              <td>
                {{ $t('apps.billing.message.user') }}
              </td>
              <td>
                {{ $t('apps.billing.message.usercount') }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.users', { number: getRangeMinMax(data.userUsedCountMin, data.userUsedCountMax, data.userUsedCount, { format: '0,0' }) }) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.unitpriceuser', { number: getCurrencyWithNumber(numberel(data.userUnitPrice, '0,0.00')) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.userAmountTotal, '0,0.00')) }}
              </td>
            </tr>
            <!-- Storeage -->
            <tr v-if="showAppRecords">
              <td :rowspan="showFile ? 2 : 1">
                {{ $t('apps.billing.message.storage') }}
              </td>
              <td>
                {{ $t('apps.billing.message.application') }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.records', { number: getRangeMinMax(data.appUsedRecordsMin, data.appUsedRecordsMax, data.appUsedRecords, { format: '0,0' }) }) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.unitpriceapplication', { number: getCurrencyWithNumber(numberel(data.appUnitPrice, '0,0.00[000000]')) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.appAmountTotal, '0,0.00[00000000]')) }}
              </td>
            </tr>
            <tr v-if="showFile">
              <td v-if="showFile && !showAppRecords">
                {{ $t('apps.billing.message.storage') }}
              </td>
              <td>
                {{ $t('apps.billing.message.file') }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.files', { number: getRangeMinMax(data.fileUsedSizeMbMin, data.fileUsedSizeMbMax, data.fileUsedSizeMb, { format: '0,0.[00]' }) }) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.unitpricefile', { number: getCurrencyWithNumber(numberel(data.fileUnitPrice, '0,0.00[000000]')) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.fileAmountTotal, '0,0.00[00000000]')) }}
              </td>
            </tr>
            <!-- Add on -->
            <tr v-if="showLineMessage">
              <td :rowspan="sum([1, showEmail ? 1 : 0, showQRCode ? 1 : 0])">
                {{ $t('apps.billing.message.addon') }}
              </td>
              <td>
                {{ $t('apps.billing.message.linemessage') }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.linemessages', { number: numberel(data.lineMessageCount, '0,0') }) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.unitpricelinemessage', { number: getCurrencyWithNumber(numberel(data.lineUnitPrice, '0,0.00[000000]')) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.lineAmountTotal, '0,0.00')) }}
              </td>
            </tr>
            <tr v-if="showEmail">
              <td
                v-if="showEmail && !showLineMessage"
                :rowspan="sum([1, showQRCode ? 1 : 0])">
                {{ $t('apps.billing.message.addon') }}
              </td>
              <td>
                {{ $t('apps.billing.message.email') }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.emails', { number: numberel(data.emailCount, '0,0') }) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.unitpriceemail', { number: getCurrencyWithNumber(numberel(data.emailUnitPrice, '0,0.00[000000]')) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.emailAmountTotal, '0,0.00')) }}
              </td>
            </tr>
            <tr v-if="showQRCode">
              <td v-if="showQRCode && !showLineMessage && !showEmail">
                {{ $t('apps.billing.message.addon') }}
              </td>
              <td>
                {{ $t('apps.billing.message.qrcode') }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.qrcodes', { number: numberel(data.qrcodeCount, '0,0') }) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.unitpriceqrcode', { number: getCurrencyWithNumber(numberel(data.qrcodeUnitPrice, '0,0.00[000000]')) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.qrcodeAmountTotal, '0,0.00')) }}
              </td>
            </tr>
          </tbody>
        </template>
      </BaseTable>
      </Col>
      <Col className="col-lg-12">
      <div class="summary-container">
        <div class="text">
          <strong>
            {{ $t('apps.billing.message.total') }}
          </strong>
        </div>
        <div class="value">
          {{ getCurrencyWithNumber(numberel(data.total, '0,0.00')) }}
        </div>
      </div>
      </Col>
    </FormRow>
  </Section>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
      default: () => ({}),
    },
    apps: {
      required: true,
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    showAppRecords () {
      return this.data.appAmountTotal > 0
    },
    showFile () {
      return this.data.fileAmountTotal > 0
    },
    showLineMessage () {
      return this.data.lineAmountTotal > 0
    },
    showEmail () {
      return this.data.emailAmountTotal > 0
    },
    showQRCode () {
      return this.data.qrcodeAmountTotal > 0
    },
    showBranches () {
      return this.data.branchAmountTotal > 0
    },
    showWarehouses () {
      return this.data.warehouseAmountTotal > 0
    },
    showUsers () {
      return this.data.userAmountTotal > 0
    },
    showApps () {
      return this.data.apps.length > 0
    },
    empty () {
      return !this.showAppRecords &&
        !this.showFile &&
        !this.showLineMessage &&
        !this.showEmail &&
        !this.showQRCode &&
        !this.showBranches &&
        !this.showWarehouses &&
        !this.showUsers &&
        !this.showApps
    },
  },

  methods: {
    getRangeMinMax (min, max, total, { format }) {
      if (min === max) {
        return this.numberel(total, format)
      }
      return `${this.numberel(min, format)} - ${this.numberel(max, format)}`
    },
  },
}
</script>

<style scoped>
.custom-table /deep/ .table tr:hover {
  background: none;
}

.summary-container {
  display: flex;
}

.summary-container .text {
  flex: 1;
  text-align: right;
}

.summary-container .value {
  width: 180px;
  padding-right: 11px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/BillingInvoiceSummary.vue